import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

registerLocaleData(localeEs);

// DSN of the Sentry `admin` project, shared by every tenant build. Errors are told
// apart by the Sentry `environment` (environment.sentryEnvironment).
const SENTRY_DSN =
  'https://851735ace5f4e126f4c7c356e2185818@o4512089764003840.ingest.de.sentry.io/4512101902254160';

// Only production builds served from a real domain report: `nx serve --configuration=
// production|fmpelota` on localhost must not send events to Sentry.
const isLocalHost = ['localhost', '127.0.0.1', '::1', '[::1]'].includes(location.hostname);
if (environment.production && !isLocalHost) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: environment.sentryEnvironment,
    release: `admin@${environment.version}`,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.05, // Sentry quota is per organization and shared by all apps: keep trace sampling low.
  });
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
